import { Auth } from 'aws-amplify';
import Button from 'react-bootstrap/Button';
import { useAuthStatus } from "../../context/AuthContext"; // 認証コンテキストから取得

const DeleteUserButton = () => {
    const { userInfo } = useAuthStatus();

    // 属性の取得
    const subStatus = userInfo?.attributes?.["custom:subscription_status"];
    const isCancelPending = userInfo?.attributes?.["custom:subscription_cancel"] === "true";

    // 制御フラグ
    const isActive = subStatus === "active";
    // 「active かつ 解約受付(true)ではない」場合のみボタンを無効化
    const isDisabled = isActive && !isCancelPending;

    async function deleteUserKakunin() {
        let message = 'アカウントを削除してもよいですか？';
        
        // 解約受付中の場合の警告文追加
        if (isActive && isCancelPending) {
            message += '\n\n【ご注意】\nアカウントを削除すると、現在利用中のサブスクリプション機能（残りの期間分）も即座に利用できなくなります。';
        }

        const result = window.confirm(message);
        if (result) {
            await deleteUser();
        }
    }

    async function deleteUser() {
        try {
            // Amplify v5形式で安全にメールアドレスを取得
            const user = await Auth.currentAuthenticatedUser();
            const srt_email = user.attributes.email;
            
            await Auth.deleteUser();
            
            alert(srt_email + ' アカウントを削除しました。');
            // 削除後は自動的にログアウトされ、リロード等で初期画面に戻ります
        } catch (error) {
            console.error("Delete user error:", error);
            alert('アカウント削除に失敗しました。しばらくした後、再度試してください。');
        }
    }

    return (
        <div className="d-grid">
            <Button 
                variant="secondary" 
                size="sm" 
                onClick={deleteUserKakunin} 
                style={{ marginTop: "10px" }}
                disabled={isDisabled}
                title={isDisabled ? "サブスクリプション解約後に削除可能になります" : ""}
            >
                アカウント削除
            </Button>
            
            {isDisabled && (
                <small className="text-danger mt-2" style={{ fontSize: '0.75rem' }}>
                    ※サブスクリプション利用中のアカウント削除はできません。先に解約手続きを完了させてください。
                </small>
            )}
        </div>
    );
};

export default DeleteUserButton;